<template>
  <div class="content">
    <div class="container">
      <form method="POST"
            action="#"
            class="form form--restore">
        <header-logo :logo-url="globalLogoUrl" />
        <h1 v-word:layout.passwordChange.header></h1>

        <div v-if="!tokenInvalid || showAll">
          <section class="form__section">
            <input-password class="form__input--password"
                            label-word="layout.passwordChange.password.label"
                            hint-word="layout.passwordChange.password.hint"
                            :wordings-editable="wordingsEditable"
                            :wordings="wordings"
                            :wordings-meta="wordingsMeta"
                            :data="formData.password"
                            @change="inputChanged"
                            @wordingChange="onWordingChange"
                            @wordingCommand="runWordingCommand"
                            :enablePlaceholder="!wordingsEditable" />

            <input-password class="form__input--password"
                            label-word="layout.passwordChange.passwordConfirm.label"
                            hint-word="layout.passwordChange.passwordConfirm.hint"
                            :wordings-editable="wordingsEditable"
                            :wordings="wordings"
                            :wordings-meta="wordingsMeta"
                            :data="formData.password_repeat"
                            @change="inputChanged"
                            @wordingChange="onWordingChange"
                            @wordingCommand="runWordingCommand"
                            :enablePlaceholder="!wordingsEditable" />
          </section>
          <section class="form__section">
            <div class="form__input form__input--submit">
              <button type="submit"
                      @click.prevent="handleSubmit()"
                      v-word:layout.passwordChange.button.submit />
            </div>
            <p v-if="serverError"
               class="form__error"
               v-word="'validation.errors.unknown'"></p>
          </section>
        </div>
        <section v-show="tokenInvalid || showAll"
                 class="form_section">
          <div class="form__section__links form__section__links--expired">
            <div class="error"
                 v-word:layout.passwordChange.expired.text />
            <div>
              <a class="button"
                 :href="!editMode && $router.resolve({ name: 'restore-password' }).href"
                 v-word:layout.passwordChange.expired.link />
            </div>
          </div>
        </section>
        <section class="form__section">
          <div class="form__section__links form__section__links--back">
            <a class="button"
               :href="!editMode && $router.resolve({ name: 'login' }).href"
               v-word:layout.passwordChange.link.backToLogin />
          </div>
        </section>

      </form>
    </div>
  </div>
</template>

<script>
import * as mixins from '../mixins';
import wordings from '../utils/wordings';
import config from 'config';
import backendConfig from '../utils/backendConfig';
import urlUtil from '../utils/url';

const formDataDef = {
  password: { '*': 1 },
  password_repeat: { '*': 1 },
};

export default {
  props: ['store', 'showAll', 'editMode'],
  mixins: [mixins.form, mixins.wordedPage, mixins.pageWithLogo],
  data() {
    return {
      serverError: false,
      formDataDef: formDataDef,
      hasErrors: false,
      token: urlUtil.parseQueryParam('token'),
      tokenInvalid: false,
    };
  },
  mounted() {
    !this.editMode &&
      this.verifyToken().catch(() => {
        this.tokenInvalid = true;
      });
  },
  methods: {
    handleSubmit() {
      this.verifyToken()
        .then(() => {
          this.submit();
        })
        .catch(() => {
          this.tokenInvalid = true;
        });
    },
    submit() {
      this.serverError = false;
      let invalid = false;

      this.hasErrors = false;
      const formData = this.marshalFormValues();

      if (!formData.password.trim()) {
        this.showFormErrors({ password: { rule: 'required' } });
        return;
      }

      if (formData.password_repeat !== formData.password) {
        this.showFormErrors({
          password_repeat: { rule: 'passwordRepeatMatch' },
        });
        return;
      }

      backendConfig.get().then(({backendUrl}) => {
        const url =
          backendUrl + config.backend.feeds.recoverPasswordChange +
          '?sso=' +
          this.store.brokerData;

        const requestData = {
          password: formData.password,
          token: this.token,
        };

        this.$emit('loading');
        this.$http
          .put(url, requestData)
          .then(function(resp) {
            this.$emit('loaded');
            this.$router.push({ path: 'change-password-success' });
            this.$emit('loaded');
          })
          .catch(function(resp) {
            if (resp.body.errors) {
              this.hasErrors = this.showFormErrors(resp.body.errors);
            } else {
              this.serverError = true;
            }
            this.$emit('loaded');
          });
          // Edge has some problem with finally
          // .finally(() => {
          //   this.$emit('loaded');
          // });
        });
    },
    verifyToken() {
      return backendConfig.get().then(({backendUrl}) => {
        const url =
          backendUrl + config.backend.feeds.verifyPasswordChangeToken +
          '?sso=' +
          this.store.brokerData;

        this.$emit('loading');
        return this.$http.post(url, { token: this.token })
        .then(() => {
          this.$emit('loaded');
        })
        .catch(() => {
          this.flash(this.wordings['flashes.generalError'], 'error');
          this.$emit('loaded');
        });
        // Edge has some problem with finally
        // .finally(() => {
        //   this.$emit('loaded');
        // });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form__input__error {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/ChangePassword.vue